/**
 * FramedFantasy Character Quest Popup + Floating Quest Icon
 *
 * Two modes controlled by data-auto-trigger on the overlay:
 *   "true"  = PDP: icon at 1.5s, popup auto-fires at scroll/time
 *   "false" = HoH: icon at 1.5s, click icon to open popup, no auto-fire
 */
(function () {
  var SCROLL_THRESHOLD = 35;
  var TIME_DELAY_MS = 12000;
  var ICON_DELAY_MS = 1500;
  var DISMISS_KEY = 'ff_quest_popup_dismissed';
  var SHOWN_SESSION_KEY = 'ff_quest_popup_shown_session';
  var DISMISS_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000; /* one week */
  var QUEST_DONE_KEY = 'ff_quest_completed';

  /*
   * Dismissal memory:
   * - Closing the popup (X, backdrop, Esc) or clicking the CTA starts a
   *   7-day cooldown stored in localStorage, shared across every page.
   * - Even if never closed, the popup auto-opens at most once per browsing
   *   session (sessionStorage), so navigating pages doesn't refire it.
   * - The floating "!" icon is never suppressed by the cooldown; opening
   *   from the icon is always allowed because the visitor asked for it.
   */
  function markDismissed() {
    var now = String(Date.now());
    try { localStorage.setItem(DISMISS_KEY, now); } catch (e) {}
    try { sessionStorage.setItem(DISMISS_KEY, now); } catch (e) {}
  }
  function inCooldown() {
    var raw = null;
    try { raw = localStorage.getItem(DISMISS_KEY); } catch (e) {}
    if (!raw) { try { raw = sessionStorage.getItem(DISMISS_KEY); } catch (e) {} }
    var t = parseInt(raw, 10);
    if (isNaN(t)) return false;
    return (Date.now() - t) < DISMISS_COOLDOWN_MS;
  }
  function shownThisSession() {
    try { return !!sessionStorage.getItem(SHOWN_SESSION_KEY); } catch (e) { return false; }
  }
  function markShownThisSession() {
    try { sessionStorage.setItem(SHOWN_SESSION_KEY, '1'); } catch (e) {}
  }

  var overlay = document.getElementById('ff-quest-popup-overlay');
  var floatBtn = document.getElementById('ff-quest-float');
  if (!overlay || !floatBtn) return;

  var autoTrigger = overlay.getAttribute('data-auto-trigger') !== 'false';

  /* Video element for play/pause control */
  var video = document.getElementById('ff-qp-video');

  /* Suppression: skip everything if quest is done */
  try {
    if (localStorage.getItem(QUEST_DONE_KEY)) return;
  } catch (e) {}

  if (document.referrer && document.referrer.indexOf('/quest') !== -1) return;
  if (window.location.search.indexOf('from_quest') !== -1) return;

  var popupOpen = false;
  var autoTriggered = false;

  function showIcon() {
    if (popupOpen) return;
    floatBtn.style.display = 'flex';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        floatBtn.classList.add('ff-qf-visible');
      });
    });
  }

  function hideIcon() {
    floatBtn.classList.remove('ff-qf-visible');
    setTimeout(function () {
      if (popupOpen) floatBtn.style.display = 'none';
    }, 300);
  }

  function showPopup() {
    if (popupOpen) return;
    popupOpen = true;
    markShownThisSession();

    if (!autoTriggered) {
      autoTriggered = true;
      window.removeEventListener('scroll', onScroll);
      if (autoTimeoutId) clearTimeout(autoTimeoutId);
    }

    hideIcon();

    overlay.style.display = 'flex';
    overlay.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('ff-qp-visible');
      });
    });

    document.body.style.overflow = 'hidden';

    /* Play video when popup opens */
    if (video) {
      try { video.play(); } catch (e) {}
    }
  }

  function hidePopup() {
    overlay.classList.remove('ff-qp-visible');
    popupOpen = false;

    /* Pause video when popup closes */
    if (video) {
      try { video.pause(); } catch (e) {}
    }

    setTimeout(function () {
      overlay.style.display = 'none';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      showIcon();
    }, 300);

    markDismissed();
  }

  /* Always show floating icon after 1.5 seconds */
  setTimeout(showIcon, ICON_DELAY_MS);

  /* Auto-trigger logic: only runs on PDP (auto_trigger = true) */
  var autoTimeoutId;
  var onScroll = function () {};

  if (autoTrigger) {
    var wasDismissed = inCooldown() || shownThisSession();

    if (!wasDismissed) {
      function getScrollPercent() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight;
        var winHeight = window.innerHeight;
        if (docHeight <= winHeight) return 100;
        return (scrollTop / (docHeight - winHeight)) * 100;
      }

      onScroll = function () {
        if (getScrollPercent() >= SCROLL_THRESHOLD) {
          showPopup();
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      autoTimeoutId = setTimeout(showPopup, TIME_DELAY_MS);
    }
  }

  /* Close handlers */
  var closeZone = document.getElementById('ff-quest-popup-close');
  if (closeZone) {
    closeZone.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      hidePopup();
    });
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      hidePopup();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popupOpen) {
      hidePopup();
    }
  });

  /* Float icon opens popup */
  floatBtn.addEventListener('click', function () {
    showPopup();
  });

  /* CTA click */
  var ctaBtn = document.getElementById('ff-quest-popup-cta');
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () {
      markDismissed();
    });
  }

})();
